module.exports = __webpack_public_path__ + "img/cooperate_23.bc80268c.png";